// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const accessRoutes = [
  route('create', '/create', Create, meta('Adicionar novo Acesso', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Acesso', true, 'guest')),
  route('index', '/index', Index, meta('Lista de Acessos', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/access', accessRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/tenant/access/routes.js